import paymentMethods from "./paymentMethods.component";

const paymentMethodsModule = angular
  .module("app.components.customerPaymentMethods", [])
  .component("paymentMethods", paymentMethods);

export default paymentMethodsModule;



// WEBPACK FOOTER //
// ./src/components/paymentMethods/paymentMethods.module.js